export default __webpack_public_path__ + "static/media/folder-open-line.b55afb76.svg";